function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" {...props}><path d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zm5.183 8.081L11.542 15.9a.852.852 0 0 1-1.385 0l-3.34-4.629a.215.215 0 0 1 .174-.34h1.256a.853.853 0 0 1 .694.356l1.907 2.646L15.059 8.1a.857.857 0 0 1 .694-.356h1.256a.215.215 0 0 1 .174.337z" /></svg>;
});